import type { IconName } from "@/types/icons";

export interface SocialMediaLink {
  name: string;
  url: string;
  icon: IconName;
}

export const socialMediaLinks: SocialMediaLink[] = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/muuuh-group/",
    icon: "linkedin",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/muuuh_group",
    icon: "instagram",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/muuuhgroup/",
    icon: "facebook",
  },
];
